export const UPDATE_SELECTED_OFF_DUTY_USERS_DATE = 'UPDATE_SELECTED_OFF_DUTY_USERS_DATE';

export const updateSelectedOffDutyUsersDate = (value) => ({
    type: UPDATE_SELECTED_OFF_DUTY_USERS_DATE,
    payload: { value }
});